import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.banking.views.SelectPaymentMethodCategoryStep'

export default defineMessages({
  selectPaymentMethodAriaLabel: {
    id: `${scope}.selectPaymentMethodAriaLabel`,
    defaultMessage: 'Select {paymentMethod} payment method',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  continueButton: {
    id: `${scope}.continueButton`,
    defaultMessage: 'Continue',
  },
})
